import { css } from '@emotion/react';

const conditionalWrapper = css`
    min-height: 15px;
    border: 1px dotted grey;
`;

export default conditionalWrapper;
